/**
 * Component: DatitudeNewsletter Section
 * ------------------------------------------------------------------------------

 *
 * @namespace DatitudeNewsletter
 */
import { getCurrentStore } from '../helpers/utils'
import { storageNamespace } from '~/helpers/storage-namespaces'

export default () => {

  const selectors = {
    newsletterForm: '#newsletter_form',
  }

  const nodeSelectors = {
    newsletterForm: document.querySelector(selectors.newsletterForm),
  }

  function returnCurrentEnvironment() {
    const currentStore = getCurrentStore()

    if (currentStore === 'staging') {
      return 'mvqa1'
    }

    return 'mv01'
  }

  function sendDatitudeNewsletter(_event) {

    const newsletterEmail = document.getElementById('SubscriberForm-Email').value
    const currentEnv = returnCurrentEnvironment()
    const myParams = {
      'account':currentEnv,
      'form_name':'[Sign Up Form]',
      'form_type':'Newsletter',
      'email':newsletterEmail,
      'email_subscriber':true,
    }

    fetch('https://app.datitude.co.uk/public-api/subscriber-centre/subscribers', {
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'API_VERSION': '1.1',
      },
      body: JSON.stringify(myParams),
    })
      .then(response => {
        if (response.ok ) {
          sessionStorage.setItem(storageNamespace.newsletterSubmit, JSON.stringify({
            email: newsletterEmail,
          }))

          window.location.href = '/pages/thankyou'
        }
      })
    // .then((res) => res.json())
      .catch(error => console.error('Error:', error))

    _event.preventDefault()
    return false
  }

  function eventListeners() {
    nodeSelectors.newsletterForm.addEventListener('submit', function (event) {
      sendDatitudeNewsletter(event)
    })
  }

  function init() {
    eventListeners()
  }

  return Object.freeze({
    init,
  })
}
